module.exports = ".layout {\n  margin: 200px auto 160px auto;\n  width: 100%;\n  max-width: 1095px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/portfolio/portfolio-routing/portfolio-routing.component.scss
// module id = ./src/app/pages/portfolio/portfolio-routing/portfolio-routing.component.scss
// module chunks = main